exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TrainingDetails-module__container___396Lp{padding:1.5rem;display:grid;gap:2rem}.TrainingDetails-module__container___396Lp .TrainingDetails-module__content-wrapper___31tZt{display:grid;gap:1rem}", ""]);

// exports
exports.locals = {
	"container": "TrainingDetails-module__container___396Lp",
	"content-wrapper": "TrainingDetails-module__content-wrapper___31tZt"
};